import { BaseService } from '@/modules/Core/services/BaseService'
import type { IFactDocumento } from '../interfaces'
import type { IFacturaGenerada, INotaCreditoGenerada } from '../interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'

export interface IGeneralFacturacion {
  tipoModalidadPago: { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
  tipoOperacion:     { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
  tipoCobertura:     { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
  tipoRecaudo:       { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
  tipoRegimen:       { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
  tipoIdent:             { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
  tipoReasonNotaCredito:  { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
  tipoResponsabilidadIva: { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
  tipoFacturaSinContrato: { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
  tipoMedioPago:          { comaId: number; comaNombrecorto: string; comaNombrelargo: string }[]
}

export class DocumentosFacturacionService extends BaseService<IFactDocumento> {
  constructor() {
    super({ baseUrl: 'facturacion/documentos/' })
  }

  general(): Promise<AxiosResponse<IResponseApi<IGeneralFacturacion>>> {
    return this.http
      .get<IResponseApi<IGeneralFacturacion>>('/general')
      .catch(this.errorHandle)
  }

  cargarMasivo(tipo: 'FACTURA' | 'NOTA_CREDITO', documentos: IFacturaGenerada[] | INotaCreditoGenerada[]): Promise<AxiosResponse<IResponseApi<IFactDocumento[]>>> {
    return this.http.post<IResponseApi<IFactDocumento[]>>(`/cargar-masivo`, { tipo, documentos }).catch(this.errorHandle)
  }

  deleteMasivo(ids: number[]): Promise<AxiosResponse<IResponseApi<number>>> {
    return this.http.delete<IResponseApi<number>>(`/delete-masivo`, { data: { ids } }).catch(this.errorHandle)
  }

  enviarUno(id: number): Promise<AxiosResponse<IResponseApi<{ ok: boolean; noDocumento: string; message: string }>>> {
    return this.http.post<IResponseApi<{ ok: boolean; noDocumento: string; message: string }>>(`/enviar/${id}`)
  }

  descargarSoportes(ids: number[]): Promise<AxiosResponse<Blob>> {
    return this.http.post<Blob>(`/descargar-soportes`, { ids }, { responseType: 'blob' }).catch(this.errorHandle)
  }
}
